import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-hd-line", title: "高清画质", desc: "精选高清影视资源，画面清晰、观感流畅。" },
  { icon: "ri-stack-line", title: "内容海量", desc: "电影、剧集、综艺一站汇集，题材覆盖全面。" },
  { icon: "ri-compass-3-line", title: "专业推荐", desc: "编辑精选榜单独家策划，帮你快速发现好内容。" },
  { icon: "ri-device-line", title: "多端适配", desc: "桌面与移动端自适应，随时随地轻松观影。" },
];

export default function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14" aria-label="网站简介">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="flex flex-col justify-center p-6 md:p-10">
            <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-vidicon-line" aria-hidden="true"></i>
              关于蘑菇视频
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专注高清影视，陪你发现每一部好作品
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              蘑菇视频致力于为影视爱好者提供丰富、清晰、便捷的内容浏览体验。从热门院线大片到口碑连载剧集，从轻松综艺到深度影视资讯，我们用心整理每一份片单，让你在碎片化的时间里，也能快速找到想看的内容。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/search"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
              >
                <i className="ri-search-line" aria-hidden="true"></i>
                搜索影视
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-px bg-background-200">
            {highlights.map((h) => (
              <div key={h.title} className="flex flex-col bg-background-100 p-5 md:p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600 text-xl">
                  <i className={h.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-sm font-semibold text-foreground-950">{h.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}